import { ICheckPasswordReq, ISetPasswordReq, ISetPinReq } from '@/core/domain/entities/request';
import { checklocal } from '@/utils';
import axios from 'axios';

export async function checkPassword(
  reqData: ICheckPasswordReq,
): Promise<{ errorCode: string; errorCount?: number } | boolean> {
  try {
    const response = await axios.post(`${checklocal()}/member/verifypassword`, reqData);

    return response.data.result;
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      if (err.response?.data.errorCount) {
        return { errorCode: err.response?.data.errorCode.code, errorCount: err.response?.data.errorCount };
      }
      return { errorCode: err.response?.data.errorCode.code };
    }

    return { errorCode: '0000' };
  }
}

export async function setPassword(
  reqData: ISetPasswordReq,
): Promise<{ errorCode: string; errorCount?: number } | boolean> {
  try {
    const response = await axios.post(`${checklocal()}/member/setpassword`, reqData);

    return response.data.result;
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      if (err.response?.data.errorCount) {
        return { errorCode: err.response?.data.errorCode.code, errorCount: err.response?.data.errorCount };
      }
      return { errorCode: err.response?.data.errorCode.code };
    }

    return { errorCode: '0000' };
  }
}

export async function withdraw(id: string): Promise<{ errorCode: string; errorCount?: number } | boolean> {
  try {
    const response = await axios.post(`${checklocal()}/member/withdraw`, { id });

    return response.data.result;
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      if (err.response?.data.errorCount) {
        return { errorCode: err.response?.data.errorCode.code, errorCount: err.response?.data.errorCount };
      }
      return { errorCode: err.response?.data.errorCode.code };
    }

    return { errorCode: '0000' };
  }
}

export async function setPin(reqData: ISetPinReq): Promise<{ errorCode: string; errorCount?: number } | boolean> {
  try {
    const response = await axios.post(`${checklocal()}/member/setpin`, reqData);

    return response.data.result;
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      if (err.response?.data.errorCount) {
        return { errorCode: err.response?.data.errorCode.code, errorCount: err.response?.data.errorCount };
      }
      return { errorCode: err.response?.data.errorCode.code };
    }

    return { errorCode: '0000' };
  }
}
